import { render, staticRenderFns } from "./TeamMembersEditForm.vue?vue&type=template&id=508fe276&scoped=true&"
import script from "./TeamMembersEditForm.vue?vue&type=script&lang=js&"
export * from "./TeamMembersEditForm.vue?vue&type=script&lang=js&"
import style0 from "./TeamMembersEditForm.vue?vue&type=style&index=0&id=508fe276&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508fe276",
  null
  
)

export default component.exports